// extracted by mini-css-extract-plugin
module.exports = {"textBoxWrp":"textarea_textBoxWrp__t_tws","error":"textarea_error__38X1d","textBox":"textarea_textBox__3z4V1","errorMsg":"textarea_errorMsg__3uF6V"};